import { getCurrentUser, isSupabaseReady } from './services/supabase.js';
import { tr } from './services/i18n.js';

const routes = {};
let currentPage = '';

function routeToRegExp(route) {
  // Replace dynamic params (e.g. :id) with a path segment matcher BEFORE escaping,
  // then escape the remaining literal characters.
  const pattern = route
    .split('/')
    .map((segment) =>
      segment.startsWith(':')
        ? '[^/]+'
        : segment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    )
    .join('/');
  return new RegExp(`^${pattern}$`);
}

export function registerRoute(path, renderFn) {
  routes[path] = renderFn;
}

export function navigate(path) {
  window.location.hash = path;
}

async function handleRoute() {
  const hash = window.location.hash || '#/login';
  const path = hash.split('?')[0];
  const routeRoot = path.split('/').slice(0, 2).join('/');
  let user = null;

  if (isSupabaseReady()) {
    try { user = await getCurrentUser(); } catch {}
  }

  const publicRoutes = ['#/login'];
  const isPublic = publicRoutes.includes(routeRoot);

  if (!user && !isPublic && !path.startsWith('#/login')) {
    navigate('#/login');
    return;
  }

  if (user && path === '#/login') {
    navigate('#/home');
    return;
  }

  const baseRoute = Object.keys(routes).find(r => {
    if (r.includes(':')) {
      return routeToRegExp(r).test(path);
    }
    return path === r;
  });

  const app = document.getElementById('app');
  if (!app) return;

  if (baseRoute && routes[baseRoute]) {
    app.innerHTML = '';
    const params = {};
    if (baseRoute.includes(':')) {
      const routeParts = baseRoute.split('/');
      const hashParts = path.split('/');
      routeParts.forEach((part, i) => {
        if (part.startsWith(':')) {
          params[part.slice(1)] = hashParts[i];
        }
      });
    }
    currentPage = hash;
    routes[baseRoute](app, params);
  } else {
    app.innerHTML = `<div class="page p-16 text-center"><h1>404</h1><p class="text-muted">${tr('Page introuvable', 'Page not found')}</p></div>`;
  }
}

export function initRouter() {
  window.addEventListener('hashchange', handleRoute);
  handleRoute();
}

export function getCurrentPage() {
  return currentPage;
}
